var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "mailCircle",
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#2F2F2F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5657 16.9143C14.6748 16.9143 13.9143 17.654 13.9143 18.6142V37.5569C13.9143 38.5172 14.6748 39.2569 15.5657 39.2569H40.434C41.3248 39.2569 42.0854 38.5172 42.0854 37.5569V18.6142C42.0854 17.654 41.3248 16.9143 40.434 16.9143H15.5657ZM11 18.6142C11 16.0872 13.0229 14 15.5657 14H40.434C42.9768 14 44.9997 16.0872 44.9997 18.6142V37.5569C44.9997 40.0839 42.9768 42.1712 40.434 42.1712H15.5657C13.0229 42.1712 11 40.0839 11 37.5569V18.6142Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2425 19.5096C11.6869 18.8386 12.591 18.655 13.2619 19.0994L27.1991 28.331C27.4443 28.4902 27.7216 28.5713 28 28.5713C28.2784 28.5713 28.5557 28.4902 28.8008 28.331L42.7381 19.0994C43.409 18.655 44.3131 18.8386 44.7575 19.5096C45.2019 20.1805 45.0183 21.0846 44.3474 21.529L30.3977 30.7689C29.6839 31.235 28.8528 31.4855 28 31.4855C27.1472 31.4855 26.3161 31.235 25.6024 30.7689L25.5944 30.7637L11.6526 21.529C10.9817 21.0846 10.7981 20.1805 11.2425 19.5096Z",
    fill: "#AAAAAA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.ef80631409963092ccd73fbe0bcc30e1.svg";
export { ForwardRef as ReactComponent };